import { useEscapeKey } from '../lib/useEscapeKey';
import { useToast } from './Toast';
import { Icon } from './icons';
import { copyToClipboard } from './shared';

export function TokenRevealModal({
  token,
  applicationName,
  onClose,
}: {
  token: string;
  applicationName: string;
  onClose: () => void;
}) {
  useEscapeKey(onClose);
  const { push } = useToast();
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: pointer-only affordance. The dialog is dismissable from the keyboard via useEscapeKey and the header close button, so the backdrop needs no key handler of its own.
    <div
      className="modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-card" style={{ maxWidth: 520 }}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Application token created</div>
            <div className="modal-sub">{applicationName}</div>
          </div>
          <button type="button" className="icon-btn" onClick={onClose} title="Close">
            <Icon.X size={14} />
          </button>
        </div>
        <div className="modal-body">
          <div className="token-warning">
            <Icon.Alert size={14} stroke="#F59E0B" />
            <span>
              This is the only time you'll see this token in full. Copy it now and store it
              somewhere safe. Lost tokens can be regenerated, but the old one is invalidated
              immediately.
            </span>
          </div>
          <div className="token-reveal">
            <code>{token}</code>
          </div>
          <button
            type="button"
            className="cta"
            onClick={() => {
              copyToClipboard(token, () => push('Token copied'));
            }}
          >
            <Icon.Copy size={13} /> Copy token
          </button>
          <div className="hint mono">Authorization: Bearer {token.slice(0, 12)}…</div>
        </div>
      </div>
    </div>
  );
}
